import {
  loadOffersForPromotions,
  type Promotion,
  type PromotionOffer,
} from '@/lib/offers-by-group';
import type { StageSliderData } from '~/lib/promotions-type';

const parseDate = (dateTimeString: string): Date | undefined => {
  // Split the date and time parts
  const [datePart, timePart] = dateTimeString.split(' ');

  // Split the date string by the dot separator
  const [day, month, year] = datePart.split('.');

  // Default to 00:00 if timePart is not provided
  let hours = 0;
  let minutes = 0;

  if (timePart) {
    // Split the time part by the colon separator
    [hours, minutes] = timePart.split(':').map(Number);
  }

  // Create and return a new Date object
  // Note: Months are 0-indexed in the Date constructor (0 is January, 1 is February, etc.)
  return new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes));
};

const getPromotionStartDate = (startDate: string | undefined): number => {
  // if undefined then startDate shouldn't matter
  // -> 0
  if (!startDate) return 0;
  return parseDate(startDate)?.getTime() || 0;
};
const getPromotionEndDate = (endDate: string | undefined): number => {
  // if undefined then endDate shouldn't matter
  // -> Infinity
  if (!endDate) return Infinity;
  return parseDate(endDate)?.getTime() || Infinity;
};

export const getActivePromotions = async (
  promotions: Promotion<StageSliderData>[],
  dateToday: number
): Promise<PromotionOffer<StageSliderData>[]> => {
  const activePromotions = promotions?.filter((promotion) => {
    if (promotion.type !== 'stage') return false;
    const startDate = getPromotionStartDate(promotion.startDate);
    const endDate = getPromotionEndDate(promotion.endDate);

    if (startDate > endDate) {
      throw new Error(`startDate can't be later then endDate for ${promotion.headline?.text}`);
    }

    return startDate < dateToday && endDate > dateToday;
  });

  return loadOffersForPromotions(activePromotions);
};
